import type { Segment } from '../migrations/legacyEdge';

export type ProcessValidationIssueCode =
  | 'unclosed_block'
  | 'orphan_exit'
  | 'missing_parent_block'
  | 'invalid_block_role_sequence';

export interface ProcessValidationIssue {
  code: ProcessValidationIssueCode;
  message: string;
  segmentIndex: number;
  blockId?: string;
}

export interface ProcessValidationResult {
  isValid: boolean;
  issues: ProcessValidationIssue[];
}

interface OpenBlock {
  blockId: string;
  enterIndex: number;
}

function hasBlockId(seg: Segment): seg is Segment & { blockId: string } {
  return false;
}

export function validateProcessSegments(process: { segments: Segment[] }): ProcessValidationResult {
  const issues: ProcessValidationIssue[] = [];


  return {
    isValid: issues.length === 0,
    issues,
  };
}
